module.exports = __webpack_public_path__ + "img/kort-1.b56fee37.jpg";